import Vue from "vue";
import Vuex from "vuex";

import axios from "axios";

import router from "./router";

Vue.use(Vuex);

axios.defaults.withCredentials = true;

export default new Vuex.Store({
  state: {
    mapKey: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    appID: process.env.VUE_APP_ID,
    title: process.env.VUE_APP_TITLE,
    apiUrl: process.env.VUE_APP_API_BASE,
    loggedIn: false,
    loading: true,
    autoDispatchEnabled: null,
    stripeKey: process.env.VUE_APP_STRIPE_KEY,
    user: {
      name: ""
    },
    center: {
      lat: Number(process.env.VUE_APP_LAT),
      lng: Number(process.env.VUE_APP_LNG)
    },
    use_zone_based_dispatch: false,
    listeningForAutodispatch: false,
    driverToMessage: null,
  },
  mutations: {
    setLoggedIn(state, payload) {
      state.loggedIn = payload;
      state.loading = false;
    },
    setAutodispatchEnabled(state, payload) {
      state.autoDispatchEnabled = payload;
    }
  },
  getters: {
    getLoggedIn(state) {
      return state.loggedIn;
    },
    getAutoDispatchEnabled(state) {
      return state.autoDispatchEnabled;
    }
  },
  actions: {
    async checkAuth({
      state,
      commit
    }) {
      axios
        .post(`${state.apiUrl}/auth/checkAuth`)
        .then(response => {
          // console.log("Logged in");
          // console.log(JSON.stringify(response));

          commit("setLoggedIn", true);

          if (!this.state.listeningForAutodispatch) {
            this.dispatch("getAutodispatch");
            this.state.listeningForAutodispatch = true;
          }

          var s = this;
          setTimeout(function () {
            s.dispatch("checkAuth");
          }, 1500);
        })
        .catch(error => {
          console.log(error);
          console.log(JSON.stringify(error));

          commit("setLoggedIn", false);

          router.push({
            name: "signin",
            // query: {
            //   redirect: route.path
            // }
          });

          var s = this;
          setTimeout(function () {
            s.dispatch("checkAuth");
          }, 1500);
        });
    },
    async login({
      state,
      commit
    }, {
      email,
      password,
      redirect
    }) {
      try {
        let response = await axios.post(
          `${state.apiUrl}/auth/login?email=${email}&password=${password}`, {
          params: {}
        }, {
          withCredentials: true
        }
        );

        commit("setLoggedIn", true);

        if (redirect != null) {
          router.push(redirect);
        } else {
          router.push("/");
        }


        if (this.state.listeningForAutodispatch == false) {
          this.dispatch("getAutodispatch");
          this.state.listeningForAutodispatch = true;
        }
      } catch (error) {

        // console.log("Network error " + JSON.stringify(error));
        commit("setLoggedIn", false);

        if (error.response != null && error.response.status == 403) {
          return "auth_failed";
        } else {
          return "network_error";
        }
      }
    },
    async logout({
      state,
      commit
    }, {
      route
    }) {
      axios
        .post(`${state.apiUrl}/auth/logout`)
        .then(response => {
          commit("setLoggedIn", false);
          router.push("/signin");
        })
        .catch(error => {
          commit("setLoggedIn", false);
          router.push("/signin");
        });
    },
    async getAutodispatch({
      state,
      commit
    }) {

      axios
        .get(`${state.apiUrl}/overwatch/isAutoDispatchEnabled`)
        .then(response => {
          var s = this;

          setTimeout(function () {
            s.dispatch("getAutodispatch");
          }, 1500);

          commit("setAutodispatchEnabled", response.data.auto_dispatch_enabled);
        })
        .catch(error => {

          // console.lNetwork errorog(" " + error);
          // console.log("Network error " + JSON.stringify(error));

          if (error.response != null && error.response.status == 403) {
            console.log("Error " + error.response);
            commit("setLoggedIn", false);
            router.push("/signin");
          } else {
            var s = this;
            setTimeout(function () {
              s.dispatch("getAutodispatch");
            }, 1500);
          }
        });
    },
    async toggleAutodispatch({
      state,
      commit
    }, {
      value
    }) {

      console.log("Toggling auto dispatch");

      axios
        .post(`${state.apiUrl}/overwatch/setAutoDispatch?enabled=${value}`)
        .then(response => {
          commit("setAutodispatchEnabled", value);
        })
        .catch(error => {
          alert("Failed to change auto dispatch");
        });
    },
  }
});